export function formatAdjustmentDate(job) {
  let value = job?.effectiveBillingDate || job?.estimatedBillingDate
  if (!value && job?.ruleVersion !== 2) {
    value = job?.nextBilling
  }
  if (!value) return 'Data indisponível'
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value.split('-').reverse().join('/')
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return 'Data indisponível'
  return new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo' }).format(date)
}
